let zipSearch = {
    sel:null,
    selError:null,
    didSearchOnce:false,
    zips: {
        'all':[], //NOTE: if adding a new county, adjust below in NOTE
    },
    init: function () {
        $('#search-zip-btn').click(zipSearch.search)
        zipSearch.sel = $('#search-zip')
        zipSearch.selError = $('#zip-error-message')

        zipSearch.sel.on('keyup',zipSearch.searchValidate)

        //configure zips
        for (let i=0;i<sitesJson.sites.length;i++) {
            let obj = sitesJson.sites[i]
            zipSearch.zips.all.push(obj.zips)
        }
        //NOTE: add new counties here

    },
    searchValidate:function() {
        let errorMsg = ''
        if (zipSearch.didSearchOnce) {
            zipSearch.errorClear()
            const val = parseInt(zipSearch.sel.val())
            const county = zipSearch.determineCounty(val)

            if (val.toString().length !== 5) {
                errorMsg = 'Please enter a valid zip code.'
            } else if (county === '') {
                errorMsg = val + ' is not in one of our counties.<br>Please use the buttons above.'
            }
            zipSearch.errorSet(errorMsg)
        }
        return errorMsg
    },
    search: function() {
        zipSearch.didSearchOnce=true
        const errorMsg = zipSearch.searchValidate()

        if (errorMsg==='') {
            const val = parseInt(zipSearch.sel.val())
            const county = zipSearch.determineCounty(val)
            if (county !== '') {
                window.location.href = county
            }
        }
    },
    determineCounty:function(val) {
        let ret = ''
        for (let i=0;i<sitesJson.sites.length;i++) {
            let obj = sitesJson.sites[i]
            let zips = obj.zips
            if (zips.indexOf(val) > -1) {
                if (isDev) {
                    ret = obj.urlDev
                } else {
                    ret = obj.urlProd
                }
            }
        }
        return ret
    },
    errorClear:function() {
        zipSearch.sel.removeClass('error')
        zipSearch.selError.html('').hide()
    },
    errorSet:function(msg) {
        if (msg === '') {
            zipSearch.errorClear()
        } else {
            zipSearch.sel.addClass('error')
            zipSearch.selError.html('<p>' + msg + '</p>').show()
        }

    }

}
export default zipSearch
